import React from 'react';
import StatusTag from 'components/ui/StatusTag';

import { getTranslatedString } from 'helpers/i18n';
import { toFriendlyDateString } from 'helpers/Formatter';

export const purchaseOrderColumns = () => {
  return [
    {
      title: getTranslatedString('landlordPortal.landlordMaintenance.status'),
      dataKey: 'status',
      sortable: false,
      width: 200,
      render: ({ data }) => <StatusTag status={data} />,
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.poNumber'),
      dataKey: 'po_number',
      sortable: true,
      width: 100,
      render: ({ data }) => data || '-',
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.title'),
      dataKey: 'title',
      sortable: true,
      width: 200,
      render: ({ data }) => {
        let title = data || '_';

        if (data != null && data.length > 15) {
          title = title.substring(0, 14) + '...';
        }
        return title;
      },
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.vendor'),
      dataKey: 'external_vendor_name',
      sortable: true,
      width: 450,
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.dueDate'),
      dataKey: 'required_date',
      sortable: true,
      width: 200,
      render: ({ data }) => {
        const date = toFriendlyDateString(data);
        if (date) return date;
        return '-';
      },
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.createdBy'),
      dataKey: 'created_by',
      sortable: false,
      width: 200,
    },
    {
      title: getTranslatedString('landlordPortal.purchaseOrders.dateSubmitted'),
      dataKey: 'created_at',
      sortable: true,
      width: 200,
      render: ({ data }) => {
        const date = toFriendlyDateString(data);
        if (date) return date;
        return '-';
      },
    },
  ];
};
